export default __webpack_public_path__ + "static/media/hht1_home_img_EP11.5c20d760.png";